import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionRequestSolicitationChangesCodes = {
  AutomationV2ExecutionActionRequestSolicitationChangesFailed: {
    code: 'automation-v2-execution-action/request-solicitation-changes-failed',
    explanation: `Falha ao tentar devolver o card ao solicitante original.

**Causas comuns:**
- O card não é uma solicitação válida
- O solicitante original não foi encontrado ou está inativo
- Problemas técnicos ao atualizar o responsável pelo formulário inicial

**Como resolver:**
Verifique se o card é uma solicitação e se o usuário que a criou ainda possui acesso ao sistema.`,
    localizations: {},
    message: 'A automação não conseguiu solicitar as alterações do formulário.',
    supportingDocs: [
      {
        name: 'Ação de Solicitar Alterações da Solicitação',
        path: '/wiki/docs/automations/actions/request-solicitation-changes',
      },
    ],
  },
  AutomationV2ExecutionActionRequestSolicitationChangesMissingCardId: {
    code: 'automation-v2-execution-action/request-solicitation-changes-missing-card-id',
    explanation: `ID do card é obrigatório para esta ação.

**Causas comuns:**
- Variável cardId não resolvida ou nula no contexto da automação.

**Como resolver:**
Certifique-se de que o ID do card está sendo passado corretamente através do contexto ou mapeamento manual.`,
    localizations: {},
    message: 'Não foi possível solicitar alterações porque o ID do card está faltando.',
    supportingDocs: [
      {
        name: 'Ação de Solicitar Alterações da Solicitação',
        path: '/wiki/docs/automations/actions/request-solicitation-changes',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
